import { render } from "./EditRankingIndustryModal.vue?vue&type=template&id=ff6525aa&scoped=true"
import script from "./EditRankingIndustryModal.vue?vue&type=script&lang=js"
export * from "./EditRankingIndustryModal.vue?vue&type=script&lang=js"

import "./EditRankingIndustryModal.vue?vue&type=style&index=0&id=ff6525aa&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff6525aa"]])

export default __exports__